<template>
  <div class="col-md-5 text-center">
    <VueSpeedometer :maxSegmentLabels="0" :segments="75" :minValue="24" :maxValue="30" :value="this.voltage"
        needleTransition="easeElastic" :needleTransitionDuration="500" currentValueText="${value} V"
        textColor="${textColor}" :width="dimensions.width" :height="dimensions.height" />
  </div>
  <div class="col-md-2 text-center d-flex align-items-center justify-content-center text-center flex-column">
    <div class="d-flex align-items-center justify-content-center">
      <p class="fs-2 mx-3 d-flex flex-column text-center">
        <span class="btn mb-3" :class="{ 'bg-success text-white': this.power >= 0, 'bg-warning': this.power < 0 }">{{
          this.$filters.formatW(this.power) }}</span>
        <span v-if="this.sonar != 0" class="material-icons fs-1">sensors</span>
        <span v-if="this.sonar != 0">{{ `${this.sonar} cm` }}</span>
      </p>
    </div>
  </div>
  <div class="col-md-5 text-center">
    <VueSpeedometer :min-value="-30" :max-value="30" :value="this.ampere" :segments="11" :maxSegmentLabels="0"
        :segment-colors="['#FA0000', '#C83200', '#966400', '#649600', '#32C800',
          '#00FA00',
          '#32C800', '#649600', '#966400', '#C83200', '#FA0000'
        ]" :needleTransitionDuration="500" :current-value-text="'${value} A'" :width="dimensions.width"
        :height="dimensions.height" />
  </div>
  <div class="col-12" v-if="this.chartData != undefined">
    <div style="height: 500px;">
      <Line :data="this.chartData" :options="this.chartOptions" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Chart as ChartJS, CategoryScale, RadialLinearScale, LinearScale, PointElement, LineElement, Filler, Title, Tooltip, Legend } from 'chart.js'
import { Line } from 'vue-chartjs'

ChartJS.register(
  CategoryScale,
  RadialLinearScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
)

export default {
  name: "awaitReloadComponent",
  components: {
    Line
  },
  props: {
    sonar: {
      type: Number,
      default: 0
    },
    voltage: {
      type: Number,
      default: 0
    },
    ampere: {
      type: Number,
      default: 0
    },
    power: {
      type: Number,
      default: 0
    },
    // power: {
    //   type: Object,
    //   default: {
    //     labels: [],
    //     datasets: [{
    //       label: "V",
    //       backgroundColor: "green",
    //       data: []
    //     },
    //     {
    //       label: "A",
    //       backgroundColor: "blue",
    //       data: []
    //     },
    //     {
    //       label: 'S',
    //       backgroundColor: "red",
    //       data: []
    //     }],
    //   }
    // },
    powerHourMod: {
      type: Boolean,
      default: true
    },
    chartData: {},
  },
  data() {
    return {
      dimensions: {
        width: 300,
        height: 200
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          tooltip: {
            mode: 'index',
            intersect: false
          },
        },
        scales: {
          x: {
            title: {
              display: false,
              text: this.$t('example')
            }
          },
        }
      },
    }
  },
  methods: {
    emitData() {
      this.$alertBox.success(this.$t('op.refreshList'))
      this.$emit("await")
    }
  }
};
</script>
